<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import Button from "primevue/button";
import TabMenu from "primevue/tabmenu";
import InputText from "primevue/inputtext";
import Sidebar from "primevue/sidebar";
import ProgressBar from "primevue/progressbar";
import CriarQuestoesOpcoes from "@/components/professor/CriarQuestoes/Opcoes.vue";
import VisualizarCardQuestao from "@/components/professor/CriarQuestoes/VisualizarCardQuestao.vue";
import ListaAvaliacoes from "@/components/professor/RecursosDidaticos/ListaAvaliacoes.vue";
import { storeToRefs } from "pinia";
import { useRecursosDidaticosStore } from "@/store/recursosDidaticosStore";
import FiltrosRecursosDidaticos from "@/components/professor/RecursosDidaticos/FiltrosRecursosDidaticos.vue";
import ListaQuestoes from "@/components/professor/RecursosDidaticos/ListaQuestoes.vue";
import CriarRecursoDidatico from "@/components/professor/RecursosDidaticos/CriarRecursoDidatico.vue";
import QuestoesDaAvaliacao from "@/components/professor/RecursosDidaticos/QuestoesDaAvaliacao.vue";
import GerenciarListaQuestoes from "@/components/professor/RecursosDidaticos/GerenciarListaQuestoes.vue";
import HeaderDetailsPage from "@/components/layout/HeaderDetailsPage.vue";
const store = useRecursosDidaticosStore();
const { questoes, tabAtiva, avaliacao, gerenciarListaQuestoesVisible, textoPesquisa, loading } = storeToRefs(store);

const router = useRouter();

function goBack() {
    router.push('/professor')
}

const items = ref([
    { label: 'Questões', icon: 'pi pi-question-circle' },
    { label: 'Avaliações', icon: 'pi pi-list-check' },
]);

const sidebarVisible = ref(false);

</script>
<template>
    <div>
        <ProgressBar v-if="loading" mode="indeterminate" style="height: 3px" class="z-5 progress-bar"></ProgressBar>
        <HeaderDetailsPage titulo="Recursos Didáticos" />
        <div class="sidebar-layout">
            <div class="sidebar-component bg-white" style="padding-top:90px">
                <FiltrosRecursosDidaticos />
            </div>
            <div class="main-component" style="padding-top:60px">
                <div class="container">
                    <div class="flex justify-content-end mb-3">
                        <CriarRecursoDidatico />
                    </div>
                    <div class="flex flex-row gap-2 mb-3">
                        <InputText v-model="textoPesquisa" size="large" type="text" placeholder="Pesquisar"
                            class="w-full" />
                        <Button icon="pi pi-search" @click="store.filtrarQuestoes()" />
                        <Button icon="pi pi-filter" class="block md:hidden" severity="secondary"
                            @click="sidebarVisible = true" />
                    </div>
                    <TabMenu :model="items" v-model:activeIndex="tabAtiva" class="mb-3" />
                    <QuestoesDaAvaliacao
                        v-if="tabAtiva === 0 && avaliacao.id !== null && avaliacao.adicionarQuestoes === true"
                        class="mb-3" />
                    <ListaQuestoes v-if="tabAtiva === 0" />
                    <ListaAvaliacoes v-if="tabAtiva === 1" />
                </div>
            </div>
        </div>
        <Sidebar v-model:visible="sidebarVisible" position="left">
            <FiltrosRecursosDidaticos />
        </Sidebar>
        <GerenciarListaQuestoes v-if="gerenciarListaQuestoesVisible" />
    </div>

</template>
<style scoped>
.sidebar-layout {
    display: flex;
    flex-direction: column;
}

.sidebar-layout .sidebar-component {
    position: fixed;
    left: 0;
    top: 0;
    width: 270px;
    height: 100vh;
    padding: 1rem;
    border-right: 1px solid var(--surface-border);
}

.sidebar-layout .main-component {
    flex-grow: 1;
    overflow-y: auto;
    margin-left: 270px;
    height: 100vh;
    padding: 0.5rem;
}



@media (max-width: 767px) {
    .sidebar-layout .sidebar-component {
        display: none;
    }

    .sidebar-layout .main-component {
        margin-left: 0;

    }
}
</style>